import React, {useCallback, useEffect, useState,} from 'react';
import i18n from '../../../i18n';
import {useTranslation} from 'react-i18next';
import './css/index.scss';
import {Link, NavLink} from 'react-router-dom';

import glowImages from './images/blue-glow.png';
import glowImages2 from './images/blue-glow-pink.png';

import arrowLeft from './images/Arrow-Right.png';
import arrowRight from './images/Arrow-Left.png';


import Particles from "react-tsparticles";
import {loadFull} from "tsparticles";


import {getPromoTemplate} from "../../../store/slices/http";
import {useDispatch, useSelector} from "react-redux";
import {PromotionChild} from '../new-promo-inside/PromotionChild';

import moment from 'moment'
import {convertLanguageCode, DEFAULT_LANGUAGE, getBannerByLanguageCode} from "../../../helper/language";
import {ONGOING} from "../../../models/promotionStatus";

i18n.on('languageChanged', (lng) => { document.documentElement.setAttribute('lang', lng); })

const Index = () => {
    const [value, setValue] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t, i18n } = useTranslation();
    const websitePromo = t('WEBSITE_PROMO', { returnObjects: true });

    const [banners, setBanners] = useState([]);

    const dispatch = useDispatch();

    const promoTemplateList = useSelector((state) => state.http.promoTemplate);
    const [promoTemplates, setPromoTemplates] = useState([]);
    const enableChild = useSelector(state => state.common.enableChild)

    function getPromoTemplates(templates, language, status) {
        let templateById = {};
        if (templates) {
            templates
              .filter((template) => template.status === status)
              .forEach((template) => {
                  const lang = convertLanguageCode(template.language);
                  if (templateById[template.promotionId]) {
                      templateById[template.promotionId][lang] = template;
                  } else {
                      templateById[template.promotionId] = {[lang]: template};
                  }
              });
        }
        return Object.values(templateById)
          .map(promotion => promotion[language] ?? promotion[DEFAULT_LANGUAGE])
          .filter(template => !!template)
          .sort((t1, t2) => {
              return t1.startAt < t2.startAt ? 1: -1;
          });
    }


    const handleChange = (newValue) => {
        setValue(newValue);
    };


    const next = () => {
        setCurrentIndex((currentIndex + 1) % banners.length);
    };

    const prev = () => {
        setCurrentIndex((currentIndex - 1 + banners.length) % banners.length);
    };



    useEffect(() => {
        dispatch(getPromoTemplate(i18n.language));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setPromoTemplates(getPromoTemplates(promoTemplateList, i18n.language, value));
    }, [promoTemplateList, i18n.language, value])

    useEffect(() => {
        let banners = [
            {
                id: 0,
                title: 'Default',
                url: getBannerByLanguageCode(i18n.language),
            }
        ];

        const ongoingPromotions = getPromoTemplates(promoTemplateList, i18n.language, ONGOING);
        if (ongoingPromotions) {
            ongoingPromotions.forEach(promo => {
                banners.push({
                    id: promo.promotionId,
                    title: 'promoBanner',
                    url: promo.landingBannerUrl,
                })
            })
        }
        setBanners(banners);
    }, [i18n.language, promoTemplateList]);


    const particlesInit = useCallback(async (engine) => {
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);
    const particlesLoaded = useCallback(async (container) => {
    }, []);
    const options = {
        background: {
            color: {
                value: "#0d47a1",
            },
        },
        fpsLimit: 120,
        interactivity: {
            events: {
                onHover: {
                    enable: false,
                    mode: "bubble",
                    parallax: {
                        enable: true,
                        force: 10,
                        smooth: 20
                    }
                }
            },
            modes: {
                bubble: {
                    distance: 150,
                    duration: 2,
                    opacity: 10,
                    size: 5,
                    speed: 15
                }
            },
        },
        particles: {
            move: {
                direction: "none",
                distance: 50,
                enable: true,
                outModes: "none",
                speed: 1
            },
            number: {
                value: 40
            },
            color: {
                value: ["#ff30b5", "#27aef3"]
            },
            shape: {
                type: "images",
                options: {
                    images: [
                        {
                            src: glowImages,
                            width: 20,
                            height: 20
                        },
                        {
                            src: glowImages2,
                            width: 20,
                            height: 20
                        },
                    ]
                }
            },
            opacity: {
                value: 1,
                random: false,
                animation: {
                    enable: true,
                    speed: .5,
                    minimumValue: 0.1,
                    sync: false
                }
            },
            size: {
                value: {
                    min: 15,
                    max: 25
                },
                random: true,
                animation: {
                    enable: true,
                    speed: 12.181158184520175,
                    minimumValue: 0.1,
                    sync: false
                },
            }
        },
        canvasMask: {
            enable: true,
            scale: 10,
            pixels: {
                filter: "pixelFilter"
            },
            image: {
                src: "https://particles.js.org/images/amongus_cyan.png"
            }
        },
        detectRetina: true,
    }

    const convertDateTime = (val) => {
        const date = new Date(val).toString().slice(4, 10);
        const time = new Date(val).toString().slice(15, 21);
        const convertedTime = moment(time, 'HH:mm').format('h:mmA');
        return date + ', ' + (convertedTime === "12:00PM" ? "12:00NN" : convertedTime);
    }

    return (
        <React.Fragment>
            {enableChild ? <PromotionChild className="promo-child" data={{ promoTemplates }}></PromotionChild> :
                <div className="bg-content1">
                    <div className="new-promo">
                        <div className="main-wrapper-class">
                            <div className='carousel-component'>
                                {/* Render the carousel */}
                                <div className='slider-container'>
                                    {/* Previous button */}
                                    {<div className='selectedButton'>
                                        <button onClick={prev} className='prev'>
                                            <img src={arrowRight} alt="Oriental Game" />
                                        </button>
                                        <div className='img-container'>
                                            {banners.map((banner) => (
                                                <Link key={banner.id} to={`${banner.id}`}>
                                                    <div
                                                        // if the photo is the current photo, show it
                                                        className={
                                                            banners[currentIndex].id === banner.id ? '' : 'slide fade'
                                                        }
                                                    >
                                                        <img src={banner.url} alt={banner.title} />
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>

                                        {/* Next button */}
                                        <button onClick={next} className='next'>
                                            <img src={arrowLeft} alt="Oriental Game" />
                                        </button>
                                    </div>}
                                </div>

                                {/* Render dots indicator */}

                            </div>

                            <div className="tab-selection">
                                <div className="menu">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th onClick={() => handleChange(1)}>
                                                    <div className={`tab-class-one ${value === 1 ? 'tab-active-one' : ''} `}>
                                                        <span>{websitePromo.ONGOING}</span>
                                                    </div>
                                                </th>
                                                <th onClick={() => handleChange(0)}>
                                                    <div className={`tab-class-two ${value === 0 ? 'tab-active-two' : ''} `}>
                                                        <span>{websitePromo.UPCOMING}</span>
                                                    </div>
                                                </th>
                                                <th onClick={() => handleChange(2)}>
                                                    <div className={`tab-class-three ${value === 2 ? 'tab-active-three' : ''} `}>
                                                        <span>{websitePromo.PREVIOUS}</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                            <div className='tab-list'>
                                {
                                    promoTemplates?.slice(0, [12, 6, 24][value])?.map((item, index) => {
                                        return (

                                            <div key={index} className='item'>
                                                <NavLink className="nav-item" to={`${item.promotionId}`}>
                                                    <div className='content-left'>
                                                        <img src={item.bannerUrl} alt="Oriental Game" data-aos="fade" data-aos-anchor-placement="bottom-bottom" />
                                                    </div>
                                                    <div className='content-right'>
                                                        <div className="details">
                                                            <span className='header-text'>
                                                                {item.title}
                                                            </span>
                                                            <span className='prize-text'>
                                                                {item.prize}
                                                            </span>
                                                            {i18n.language === 'en' ? <span className='promo-details'>{websitePromo.PROMO_STARTS + " " + convertDateTime(item.startAt) + " " + websitePromo.PROMO_ENDS}</span > : <span className='promo-details'>{websitePromo.PROMOTION + " " + convertDateTime(item.startAt) + " " + websitePromo.PROMO_STARTS}</span >}
                                                            <div>
                                                                {i18n.language === 'en' ? <span className='promo-details'>{convertDateTime(item.endAt)}</span> : <span className='promo-details'> {convertDateTime(item.endAt) + " " + websitePromo.PROMO_ENDS}</span>}
                                                            </div>
                                                            <span className='promo-details'>
                                                                {websitePromo.promo_period}
                                                            </span>
                                                            <div className="promo-btn">
                                                                <span>{websitePromo.more_details}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            </div>

                                        )
                                    })
                                }
                            </div>
                        </div>
                        <Particles id="tsparticles" init={particlesInit} loaded={particlesLoaded} options={options} />
                    </div>
                </div>
            }
        </React.Fragment >
    )
}

export default Index